// extracted by mini-css-extract-plugin
export var fadeIn = "_27-0";